const LOOKER_EMBED_HOST = 'trove.looker.com';

interface TrustedTypesLike {
  createPolicy: (
    name: string,
    rules: { createScriptURL: (url: string) => string }
  ) => { createScriptURL: (url: string) => unknown };
}

let cachedPolicy: ReturnType<TrustedTypesLike['createPolicy']> | undefined;

const getPolicy = () => {
  const trustedTypes = (window as unknown as { trustedTypes?: TrustedTypesLike }).trustedTypes;
  if (!trustedTypes) return undefined;

  if (!cachedPolicy) {
    cachedPolicy = trustedTypes.createPolicy('looker-embed', {
      createScriptURL: (url: string) => {
        const { hostname } = new URL(url);
        if (hostname !== LOOKER_EMBED_HOST) {
          throw new Error(`Refusing to embed unexpected Looker host: ${hostname}`);
        }
        return url;
      },
    });
  }

  return cachedPolicy;
};

/**
 * Assigning a raw string to iframe.src is a guarded Trusted Types sink (it
 * can be used for javascript: URL injection). Routes the signed embed URL
 * through a policy that also validates it points at the expected Looker
 * host, falling back to a plain string where Trusted Types isn't supported.
 */
export const toTrustedIframeSrc = (url: string): string => {
  const policy = getPolicy();
  return (policy ? policy.createScriptURL(url) : url) as string;
};
